import React, { useState, useRef, useEffect } from "react"
import { getConfig } from "@/constants/config"
import {
  decodeHtmlCharacters,
  getShortenedUrlwithGeneral,
  scrollToElement,
} from "@/utils/helper"
import {
  addDownloadFilesAnalyticsInstSup,
  getEventInfoInstSup,
} from "@/components/ProductDetail/v3/ProductAccordionList/analytics"
import { useSelector } from "react-redux"
import { selectGenericState } from "@/store/features/genericSlice"

import VideoModal from "@/components/VideoWrapper/VideoModal"
import PartsViewer from "@/components/PartsViewer/v1/PartsViewer"
import PartsViewerV2 from "@/components/PartsViewer/v2/PartsViewer"

import videoIcon from "@/public/icons/video-file.svg"
import partsIcon from "@/public/icons/parts-diagram.svg"
import downloadIcon from "@/public/icons/download-dark-gray.svg"

const InstallationSupport = props => {
  const {
    files = {},
    staticTexts = {},
    productInfo = {},
    svgFileMap = [],
  } = props
  const [videoModal, setVideoModal] = useState({ show: false, id: "" })
  const [partsModal, setPartsModal] = useState({ show: false, id: "" })
  const [general, setGeneral] = useState(null)
  const partsRef = useRef(null)
  const videoRef = useRef(null)

  useEffect(() => {
    getConfig().then(config => {
      setGeneral(config?.general)
    })
  }, [])

  const handleDownload = (e, link, title) => {
    e.stopPropagation()
    const linkUrl = link.trim()
    let errMsg
    try {
      window.open(linkUrl, "_blank")
    } catch (err) {
      errMsg = err.message
    }
    addDownloadFilesAnalyticsInstSup(productInfo, title, errMsg, linkUrl)
  }

  const closeModal = type => {
    if (type === "parts") {
      scrollToElement(partsRef)
      setPartsModal({ show: false, id: "" })
    } else if (type === "video") {
      scrollToElement(videoRef)
      setVideoModal({ show: false, id: "" })
    }
  }

  const { featureFlags } = useSelector(selectGenericState)
  const {
    MYSQLCONNSTR_ENABLE_PARTS_VIEWER_V2: isPartsViewerV2Enabled = false,
  } = featureFlags

  return (
    <>
      {partsModal.show &&
        (isPartsViewerV2Enabled ? (
          <PartsViewerV2
            productId={files.productId}
            partId={partsModal.id}
            showModal={partsModal.show}
            page="pdp"
            onClose={() => closeModal("parts")}
            analyticsCustomData={productInfo}
            fileMap={svgFileMap}
          />
        ) : (
          <PartsViewer
            productId={files.productId}
            partId={partsModal.id}
            showModal={partsModal.show}
            page="pdp"
            onClose={() => closeModal("parts")}
            analyticsCustomData={productInfo}
          />
        ))}
      {videoModal.show && (
        <VideoModal
          videoId={videoModal.id}
          onClose={() => closeModal("video")}
        />
      )}
      <div className="pdp-install-support__download-section">
        {(files.guides.installationGuides.length > 0 ||
          files.guides.supportGuides.length > 0 ||
          files.videos.length > 0 ||
          files.partsLinks.length > 0) && (
          <div className="pdp-support-files__install-support">
            <div className="pdp-support-files__install">
              {(files.guides.installationGuides.length > 0 ||
                files.guides.supportGuides.length > 0) && (
                <div
                  className={`pdp-technical-tile__files --technical-info --installation ${
                    files.guides.supportGuides.length > 0
                      ? "--technical-info__border"
                      : ""
                  }`}
                >
                  <div className="pdp-support-files__sub-heading">
                    {staticTexts.guides}
                  </div>
                  {files?.guides?.installationGuides &&
                    files.guides.installationGuides.map((item, i) => (
                      <section key={i}>
                        <div
                          className="pdp-technical-tile__file"
                          onClick={e => handleDownload(e, item.url, item.title)}
                        >
                          <img
                            alt=""
                            aria-hidden="true"
                            src={downloadIcon?.src}
                          />
                          {item.title}
                        </div>
                      </section>
                    ))}
                  {files?.guides?.supportGuides &&
                    files.guides.supportGuides.map((item, i) => (
                      <section key={i}>
                        <div
                          className="pdp-technical-tile__file"
                          onClick={e => handleDownload(e, item.url, item.title)}
                        >
                          <img
                            alt=""
                            aria-hidden="true"
                            src={downloadIcon?.src}
                          />
                          {item.title}
                        </div>
                      </section>
                    ))}
                </div>
              )}
            </div>
            {files.videos.length > 0 && (
              <div
                className={`pdp-support-files__support ${
                  files.guides.installationGuides.length +
                    files.guides.supportGuides.length ===
                  0
                    ? "mt-0"
                    : ""
                }`}
              >
                <div className="pdp-support-files__sub-heading">
                  {staticTexts.installVideo}
                </div>
                {files.videos.length > 0 && (
                  <div
                    className="pdp-support-files__videos"
                    role="list"
                    ref={videoRef}
                  >
                    {files.videos.map((item, i) => (
                      <section key={item.id} role="listitem">
                        <div
                          className="pdp-support-files__links gbh-data-layer pdp-support-files__file-type"
                          data-gbh-data-layer={getEventInfoInstSup(
                            item.title,
                            "installation video"
                          )}
                          data-gbh-data-layer-custom={productInfo}
                          onClick={() =>
                            setVideoModal({ show: true, id: item.id })
                          }
                        >
                          <img alt="" aria-hidden="true" src={videoIcon?.src} />
                          {item.title}
                        </div>
                      </section>
                    ))}
                  </div>
                )}
              </div>
            )}
            {files.partsLinks.length > 0 && (
              <div
                className={`pdp-support-files__parts-links ${
                  files.guides.installationGuides.length +
                    files.guides.supportGuides.length +
                    files.videos.length ===
                  0
                    ? "mt-0"
                    : ""
                }`}
              >
                <div className="pdp-support-files__sub-heading">
                  {staticTexts.partsDiagram}
                </div>
                <div
                  className="pdp-support-files__parts-link"
                  role="list"
                  ref={partsRef}
                >
                  {files.partsLinks.map((item, i) => (
                    <section key={item.id} role="listitem">
                      <div
                        role="button"
                        tabIndex="0"
                        className="pdp-support-files__links gbh-data-layer"
                        data-gbh-data-layer={getEventInfoInstSup(
                          item.title,
                          "interactive parts diagram",
                          true
                        )}
                        data-gbh-data-layer-custom={productInfo}
                        onClick={() =>
                          setPartsModal({ show: true, id: item.id })
                        }
                      >
                        <img alt="" aria-hidden="true" src={partsIcon?.src} />
                        {item.title}
                      </div>
                    </section>
                  ))}
                </div>
              </div>
            )}

            {files.pdfPartsLinks.length > 0 && (
              <div
                className="pdp-support-files__install pdf-support-files"
                role="list"
              >
                <div
                  className={`pdp-technical-tile__files --technical-info --installation ${
                    files.pdfPartsLinks.length > 0
                      ? "--technical-info__border"
                      : ""
                  }`}
                >
                  <div className="pdp-support-files__sub-heading">
                    {staticTexts.partsDiagram}
                  </div>
                  {files.pdfPartsLinks.map((item, i) => (
                    <section key={i}>
                      <div
                        className="pdp-technical-tile__file"
                        onClick={e => handleDownload(e, item.id, item.title)}
                      >
                        <img
                          alt=""
                          aria-hidden="true"
                          src={downloadIcon?.src}
                        />
                        {item.title}
                      </div>
                    </section>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
        {files.supportLinks.length > 0 && (
          <div className="pdp-support-files__support-links">
            <div className="pdp-support-files__sub-heading">
              {staticTexts.helpfulLinks}
            </div>
            <div className="pdp-support-files__support-link" role="list">
              {files.supportLinks.map((item, i) => (
                <section key={i} role="listitem">
                  <a
                    className="pdp-support-files__links gbh-data-layer"
                    data-gbh-data-layer={getEventInfoInstSup(
                      item.ctaLabel,
                      "",
                      false,
                      item.ctaLink
                    )}
                    data-gbh-data-layer-custom={productInfo}
                    href={getShortenedUrlwithGeneral(item?.ctaLink, general)}
                    target={item.newTab ? "_blank" : ""}
                    rel="noreferrer"
                  >
                    {decodeHtmlCharacters(item.ctaLabel)}
                  </a>
                </section>
              ))}
            </div>
          </div>
        )}
      </div>
    </>
  )
}

export default InstallationSupport
